import { type ApplicantFilter } from "../../lib/hiringApplicationFilter";


export type HiringSection = "applicants" | "direct" | "talent";

export type DirectStatus = "pending" | "ready" | "active" | "declined" | "completed" | "cancelled";

export type DirectFilter = "all" | DirectStatus;

export type DirectHireContract = {
  id: string;
  title: string;
  counterparty: string | null;
  counterpartyUserId: number;
  status: "pending_funding" | "funded" | "completed" | "cancelled";
  offerStatus: "pending" | "accepted" | "declined";
  createdAt: string;
};

export const applicantFilters: { key: ApplicantFilter; label: string }[] = [
  { key: "all", label: "All" }, { key: "applied", label: "Applied" },
  { key: "shortlisted", label: "Shortlisted" }, { key: "offers", label: "Pending offers" }, { key: "accepted", label: "Hired" },
  { key: "rejected", label: "Rejected" },
];

export const directFilters: { key: DirectFilter; label: string }[] = [
  { key: "all", label: "All" }, { key: "pending", label: "Pending" },
  { key: "ready", label: "Ready to fund" }, { key: "active", label: "Active" },
  { key: "declined", label: "Declined" }, { key: "completed", label: "Completed" },
  { key: "cancelled", label: "Cancelled" },
];

export function readHiringState(key: string): { jobId: string; identity: boolean; profession: boolean; section: HiringSection; applicant: ApplicantFilter; direct: DirectFilter; scrollY: number } {
  let saved: unknown = null;
  try { saved = JSON.parse(sessionStorage.getItem(key) || "null"); } catch { /* Storage may be unavailable; use the current route defaults. */ }
  const state = { jobId: saved && typeof saved === "object" && "jobId" in saved ? saved.jobId : null,
    identity: saved && typeof saved === "object" && "identity" in saved ? saved.identity : false,
    profession: saved && typeof saved === "object" && "profession" in saved ? saved.profession : false,
    section: saved && typeof saved === "object" && "section" in saved ? saved.section : null,
    applicant: saved && typeof saved === "object" && "applicant" in saved ? saved.applicant : null,
    direct: saved && typeof saved === "object" && "direct" in saved ? saved.direct : null,
    scrollY: saved && typeof saved === "object" && "scrollY" in saved ? saved.scrollY : 0 };
  return { jobId: typeof state.jobId === "string" ? state.jobId : "", identity: state.identity === true, profession: state.profession === true,
    section: state.section === "direct" || state.section === "talent" ? state.section : "applicants",
    applicant: applicantFilters.find(filter => filter.key === state.applicant)?.key || "all",
    direct: directFilters.find(filter => filter.key === state.direct)?.key || "all",
    scrollY: typeof state.scrollY === "number" && Number.isFinite(state.scrollY) ? state.scrollY : 0 };
}

export function isDirectHireContract(value: unknown): value is DirectHireContract {
  if (!value || typeof value !== "object") return false;
  const contract = value as Record<string, unknown>;
  return contract.sourceType === "hire" && contract.role === "buyer"
    && typeof contract.id === "string" && typeof contract.title === "string"
    && typeof contract.counterpartyUserId === "number" && typeof contract.createdAt === "string"
    && typeof contract.status === "string" && typeof contract.offerStatus === "string";
}

export function directStatus(contract: DirectHireContract): DirectStatus {
  if (contract.status === "cancelled") return contract.offerStatus === "declined" ? "declined" : "cancelled";
  if (contract.status === "completed") return "completed";
  if (contract.status === "funded") return "active";
  return contract.offerStatus === "accepted" ? "ready" : "pending";
}
